import React, { JSXElementConstructor, ReactElement } from 'react'
import TooltipLib from 'rc-tooltip'

import { Plus } from 'lucide-react'
import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import { Button } from '@/components/v2/Button'
import {
  Tooltip as TooltipV2,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
  TooltipArrow,
} from '@/components/v2/Tooltip'

interface TooltipProps {
  title?: JSX.Element | string
  position?: 'right' | 'left' | 'bottom' | 'top'
  children: ReactElement<any, string | JSXElementConstructor<any>> | undefined
}

type AllTooltipProps = TooltipProps &
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Root>

export default function Tooltip({
  position,
  title,
  children,
  ...rest
}: AllTooltipProps) {
  return (
    <TooltipProvider>
      <TooltipV2 {...rest}>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent className="z-20" side={position}>
          <div>{title}</div>
          <TooltipArrow />
        </TooltipContent>
      </TooltipV2>
    </TooltipProvider>
  )
}

export function ConditionalTooltip({
  disabled,
  children,
  ...rest
}: AllTooltipProps & { disabled?: boolean }) {
  if (disabled) return <>{children}</>

  return <Tooltip {...rest}>{children}</Tooltip>
}

export function TooltipTitleLayout({
  children,
}: {
  children: React.ReactNode
}) {
  return <div className="flex flex-col gap-2 py-2 w-72">{children}</div>
}
